import { render, staticRenderFns } from "./customer_sales_by_month.vue?vue&type=template&id=4197e85a&"
import script from "./customer_sales_by_month.vue?vue&type=script&lang=js&"
export * from "./customer_sales_by_month.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports